<script>
    import { handleScoopAjaxError } from '../../../../resources/js/mixins/axios-response-errors'

    export default {
        props: {
            package: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                shareWithUser: null,
                options: [],
            }
        },
        methods: {
            onSearch(search, loading) {
                loading(true);
                this.search(loading, search, this);
            },
            search: _.debounce((loading, search, vm) => {
                axios.get(Scoop.baseUrl + '/mediaserver/components/share-users-create', { params: { q: search }})
                    .then(response => {
                        vm.options = response.data.items;
                        loading(false);
                    });
            }, 250),
            addUserShare() {
                axios.post(Scoop.baseUrl + '/mediaserver/packages/' + this.package.id + '/shareuser', {
                    email: this.shareWithUser.email
                })
                    .then(response => {
                        toastr.info('User has been added');
                        this.$emit('packageChanged', response.data);
                    }).catch(error => handleScoopAjaxError(error, 'Could not add user'));

                this.shareWithUser = '';
            },
        },
    }
</script>
<template>
    <div class="package-share-users-create">
        <div class="input-group">
            <v-select
                    v-model="shareWithUser"
                    :filterable="false"
                    :options="options"
                    @search="onSearch"
            >
                <template slot="no-options">
                    {{ __('scoop-os.packages.share.placeholder_share_with') }}
                </template>
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        <img :src='option.avatar_url'/>
                        <span v-html="option.label"></span>
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                        <img :src='option.avatar_url'/>
                        <span v-html="option.label"></span>
                    </div>
                </template>
            </v-select>
            <div class="input-group-btn">
                <input type="button"
                       @click="addUserShare"
                       class="btn btn-primary"
                       :disabled="!shareWithUser"
                       :value="__('scoop-os.packages.share.button_label')">
            </div>
        </div>
    </div>
</template>
<style>
    .package-share-users-create img {
        height: auto;
        max-width: 2.5rem;
        margin-right: 1rem;
    }

    .d-center {
        display: flex;
        align-items: center;
    }

    .package-share-users-create .selected img {
        width: auto;
        max-height: 23px;
        margin-right: 0.5rem;
    }

    .package-share-users-create .v-select .dropdown li {
        border-bottom: 1px solid rgba(112, 128, 144, 0.1);
    }

    .package-share-users-create .v-select .dropdown li:last-child {
        border-bottom: none;
    }

    .package-share-users-create .v-select .dropdown li a {
        padding: 10px 20px;
        width: 100%;
        font-size: 1.25em;
        color: #3c3c3c;
    }

    .package-share-users-create .v-select .dropdown-menu .active > a {
        color: #fff;
    }
</style>